export default "__VITE_ASSET__C06C7W2y__"